import React, { FC } from 'react'

import styled, { css } from 'styled-components'

import { Txt } from 'src/components/atoms'

const CircleBase = css`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: relative;

  &:after {
    display: block;
    content: '';
    width: 8px;
    height: 8px;
    // TODO: styled-componentsを使わないようにする
    background-color: #fff;
    position: absolute;
    border-radius: 50%;
    top: 2px;
    left: 2px;
  }
`

const GradientCircle = styled.div`
  ${CircleBase};
  background: linear-gradient(#05a19a 0%, #97ba3c 100%);
`
const PredictionCircle = styled.div`
  ${CircleBase};
  // TODO: styled-componentsを使わないようにする
  background: #cbd0d6;
`

type Props = {
  className?: string
}

export const ProjectUsageTrendChartLegend: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <div className="tw-text-standardText-secondary tw-centering tw-gap-r2">
        <div className="tw-centering">
          <GradientCircle />
          <Txt sizeType="s" className="tw-ml-s-4">
            実績値
          </Txt>
        </div>
        <div className="tw-centering">
          <PredictionCircle />
          <Txt sizeType="s" className="tw-ml-s-4">
            未確定
          </Txt>
        </div>
      </div>
    </div>
  )
}
